import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cmpts-buttondropdown',
  templateUrl: './buttondropdown.component.html',
  styleUrls: ['./buttondropdown.component.css']
})
export class ButtondropdownComponent implements OnInit {
  bordersControl1 = new FormControl();

  constructor() { }

  ngOnInit(): void {
  }

  selectclick(mySelect1, event){
    mySelect1.open();
    event.preventDefault();
  }
}
